module.exports = __webpack_public_path__ + "static/media/down_arrow.c8d27a5f.svg";